(function () {
  'use strict';

  // Global function to update variant ID when dropdown changes
  window.updateUpsellVariant = function (selectEl) {
    var card = selectEl.closest('.product-upsell-card');
    if (!card) return;

    var checkbox = card.querySelector('.product-upsell-checkbox');
    var selectedOption = selectEl.options[selectEl.selectedIndex];
    var newVariantId = selectedOption.value;
    var newPrice = parseInt(selectedOption.getAttribute('data-price'), 10);
    var discountPct = parseInt(selectEl.getAttribute('data-discount-pct'), 10) || 0;
    // Exact-dollar override (in cents). Wins over the percentage when set, matching
    // resolve_upsell_discount_cents() in the Rust function.
    var discountAmountCents = parseInt(selectEl.getAttribute('data-discount-amount'), 10) || 0;
    var hasDiscount = discountPct > 0 || discountAmountCents > 0;

    // Update checkbox data attribute
    if (checkbox) {
      checkbox.setAttribute('data-variant-id', newVariantId);
    }

    // Update card image to match selected variant
    var variantImageUrl = selectedOption.getAttribute('data-image');
    var imgEl = card.querySelector('.upsell-product-image');
    if (imgEl) {
      if (variantImageUrl) {
        imgEl.src = variantImageUrl;
      } else {
        // Fall back to product featured image
        var imgContainer = imgEl.closest('[data-fallback-image]');
        if (imgContainer) {
          imgEl.src = imgContainer.getAttribute('data-fallback-image');
        }
      }
    }

    // Update price display
    var priceDisplay = card.querySelector('.upsell-price-display');
    if (priceDisplay && newPrice) {
      var formattedPrice = Shopify.formatMoney ? Shopify.formatMoney(newPrice) : '$' + (newPrice / 100).toFixed(2);

      if (hasDiscount) {
        var discountedEl = priceDisplay.querySelector('.upsell-discounted-price');
        var originalEl = priceDisplay.querySelector('.upsell-original-price');

        if (discountPct === 100) {
          if (discountedEl) discountedEl.textContent = 'FREE';
          if (originalEl) originalEl.textContent = formattedPrice;
        } else {
          // Mirror the Rust function: dollar override wins, else pct rounded UP to a whole
          // dollar. Clamped to the price so the discount can never exceed the line.
          var actualDiscountCents;
          if (discountAmountCents > 0) {
            actualDiscountCents = discountAmountCents;
          } else {
            var rawDiscountCents = Math.round(newPrice * discountPct / 100);
            actualDiscountCents = Math.ceil(rawDiscountCents / 100) * 100;
          }
          if (actualDiscountCents > newPrice) actualDiscountCents = newPrice;
          var discountedPrice = newPrice - actualDiscountCents;
          var savingsDollars = actualDiscountCents / 100;
          var formattedDiscounted = Shopify.formatMoney ? Shopify.formatMoney(discountedPrice) : '$' + (discountedPrice / 100).toFixed(2);

          if (discountedEl) discountedEl.textContent = formattedDiscounted;
          if (originalEl) originalEl.textContent = formattedPrice;

          // Rule of 100: update badge text to match new variant's savings
          var badgeEl = card.querySelector('.upsell-badge');
          if (badgeEl) {
            badgeEl.textContent = (discountAmountCents > 0 || savingsDollars > discountPct)
              ? 'Save $' + savingsDollars
              : 'Save ' + discountPct + '%';
          }
        }
      } else {
        var priceEl = priceDisplay.querySelector('.upsell-price');
        if (priceEl) priceEl.textContent = formattedPrice;
      }
    }
  };

  // Listen for main variant changes and update upsell pre-selections dynamically
  function getSelectedOptions(eventDetail) {
    var options = [];

    // Method 0: Use event detail directly (most reliable for Enterprise 2.2)
    if (eventDetail && eventDetail.selectedOptions) {
      return eventDetail.selectedOptions;
    }

    // Method 1: variant-selects custom element (Dawn theme)
    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      variantSelects.querySelectorAll('select').forEach(function(sel) {
        if (sel.value) options.push(sel.options[sel.selectedIndex].textContent.trim());
      });
      if (options.length) return options;
    }

    // Method 2: variant-radios custom element
    var variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      variantRadios.querySelectorAll('input[type="radio"]:checked').forEach(function(rad) {
        options.push(rad.value);
      });
      if (options.length) return options;
    }

    // Method 3: Fieldsets with option names (Enterprise 2.2 + Dawn)
    document.querySelectorAll('fieldset.option-selector, fieldset.product-form__input').forEach(function(fieldset) {
      var checked = fieldset.querySelector('input:checked');
      if (checked) options.push(checked.value);
    });

    return options.length ? options : null;
  }

  function handleMainVariantChange(e) {
    var eventDetail = e && e.detail ? e.detail : null;
    var selectedOptions = getSelectedOptions(eventDetail);
    if (!selectedOptions || !selectedOptions.length) return;

    // Cards gated to one main option value (source_option_value): show/hide, and untick when hidden
    document.querySelectorAll('.product-upsell-card[data-show-for-option]').forEach(function(card) {
      var show = selectedOptions.indexOf(card.getAttribute('data-show-for-option')) !== -1;
      card.hidden = !show;
      var cb = card.querySelector('.product-upsell-checkbox');
      if (!show && cb && cb.checked) {
        cb.checked = false;
        card.classList.remove('is-checked');
      }
    });

    // For each upsell dropdown, try to match using fuzzy word matching
    document.querySelectorAll('.upsell-variant-select').forEach(function(select) {
      var options = select.querySelectorAll('option');
      var matched = false;

      selectedOptions.forEach(function(mainOpt) {
        if (matched) return;
        var mainOptLower = mainOpt.toLowerCase();
        var mainWords = mainOptLower.split(' ').filter(function(w) { return w.length > 3; });

        options.forEach(function(opt) {
          if (matched) return;
          var targetText = opt.textContent.toLowerCase();

          // First try exact match
          if (targetText.indexOf(mainOptLower) !== -1 || mainOptLower.indexOf(targetText.split(' ')[0]) !== -1) {
            select.value = opt.value;
            window.updateUpsellVariant(select);
            matched = true;
            return;
          }

          // Then try word-based fuzzy match
          mainWords.forEach(function(word) {
            if (matched) return;
            if (targetText.indexOf(word) !== -1) {
              select.value = opt.value;
              window.updateUpsellVariant(select);
              matched = true;
            }
          });
        });
      });
    });
  }

  function initVariantSync() {
    // Listen for Enterprise 2.2 theme's custom variant change event
    document.addEventListener('on:variant:change', handleMainVariantChange);

    // Also keep Dawn event for backwards compatibility
    document.addEventListener('variant:change', handleMainVariantChange);

    // Listen for changes on variant-picker element (Enterprise 2.2)
    var variantPicker = document.querySelector('variant-picker');
    if (variantPicker) {
      variantPicker.addEventListener('change', handleMainVariantChange);
    }

    // Listen for changes on variant selectors directly (Dawn fallbacks)
    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      variantSelects.addEventListener('change', handleMainVariantChange);
    }

    var variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      variantRadios.addEventListener('change', handleMainVariantChange);
    }

    // Also listen on any fieldsets with product form inputs (Enterprise 2.2 + Dawn)
    document.querySelectorAll('fieldset.option-selector, fieldset.product-form__input').forEach(function(fieldset) {
      fieldset.addEventListener('change', handleMainVariantChange);
    });
  }

  // Quantity multiplier: recalculate upsell qty based on main product qty
  function updateMultipliedQuantities() {
    var form = document.querySelector('product-form form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    var mainQtyInput = form.querySelector('input[name="quantity"]');
    var mainQty = mainQtyInput ? (parseInt(mainQtyInput.value, 10) || 1) : 1;

    var cards = document.querySelectorAll('.product-upsell-card[data-qty-per-unit]');
    cards.forEach(function(card) {
      var perUnit = parseInt(card.getAttribute('data-qty-per-unit'), 10);
      if (perUnit > 0) {
        var qtyInput = card.querySelector('.upsell-qty-input');
        if (qtyInput) {
          qtyInput.value = perUnit * mainQty;
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Initialize variant sync for dynamic updates
    initVariantSync();
    var form = document.querySelector('product-form form[action*="/cart/add"]')
      || document.querySelector('form[action*="/cart/add"]');

    if (!form) return;

    // Set up main product qty listener for multiplied upsell quantities
    var mainQtyInput = form.querySelector('input[name="quantity"]');
    if (mainQtyInput) {
      mainQtyInput.addEventListener('change', updateMultipliedQuantities);
      // Also listen for click on +/- buttons (theme qty steppers use these)
      var qtyButtons = form.querySelectorAll('.quantity__button');
      qtyButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          setTimeout(updateMultipliedQuantities, 50); // Wait for value update
        });
      });
    }

    // Set initial multiplied quantities on page load
    updateMultipliedQuantities();

    // Use capture phase to fire BEFORE the theme's product-form handler.
    // This handler is the unified owner of multi-item ATC: it collects
    // checked upsells AND any product-configurator selections, so both
    // can ride along on a single /cart/add.js call.
    form.addEventListener('submit', function (e) {
      var upsellContainer = document.querySelector('.product-upsells');
      var checked = upsellContainer
        ? upsellContainer.querySelectorAll('input[type="checkbox"][data-variant-id]:checked')
        : [];

      // Configurator slots (Michell pick-one tonearm/cartridge, etc.)
      var configuratorExtras = [];
      var configuratorRoot = document.querySelector('[data-configurator]');
      if (configuratorRoot) {
        configuratorRoot.querySelectorAll('[data-configurator-slot]').forEach(function (slot) {
          var selected = slot.querySelector('custom-select [aria-selected="true"]');
          if (selected && selected.dataset.variantId) {
            var cid = parseInt(selected.dataset.variantId, 10);
            if (cid) configuratorExtras.push({ id: cid, quantity: 1 });
          }
        });
      }

      if (!checked.length && !configuratorExtras.length) return;

      // Upsells and/or configurator have items - take over submission
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevents theme's handler from also firing

      // Resolve the main product variant ID
      // The form's own input[name="id"] is disabled and stale after a variant change
      // (main-product.liquid); the variant picker holds the selected variant (TASK-1247).
      var mainVariantId = null;
      var picker = (form.closest('.shopify-section') || document).querySelector('variant-picker');
      var hiddenInput = form.querySelector('input[name="id"]');
      var variantSelect = form.querySelector('select[name="id"]');

      if (picker && picker.variant && picker.variant.id) {
        mainVariantId = parseInt(picker.variant.id, 10);
      } else if (hiddenInput) {
        mainVariantId = parseInt(hiddenInput.value, 10);
      } else if (variantSelect) {
        mainVariantId = parseInt(variantSelect.value, 10);
      }

      if (!mainVariantId) {
        console.error('[product-upsells] Could not determine main variant ID');
        return;
      }

      // Resolve main product quantity (default 1)
      var qtyInput = form.querySelector('input[name="quantity"]');
      var mainQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      // Build items array: main variant + configurator extras + upsell extras
      var items = [{ id: mainVariantId, quantity: mainQty }];

      configuratorExtras.forEach(function (extra) {
        items.push(extra);
      });

      checked.forEach(function (cb) {
        var card = cb.closest('.product-upsell-card');
        if (card && card.hidden) return;
        var selectEl = card ? card.querySelector('.upsell-variant-select') : null;
        var vid;

        // If there's a variant dropdown, use its value; otherwise use checkbox data attribute
        if (selectEl) {
          vid = parseInt(selectEl.value, 10);
        } else {
          vid = parseInt(cb.getAttribute('data-variant-id'), 10);
        }

        if (vid) {
          var upsellQtyInput = card ? card.querySelector('.upsell-qty-input') : null;
          var upsellQty = upsellQtyInput ? parseInt(upsellQtyInput.value, 10) || 1 : 1;
          items.push({ id: vid, quantity: upsellQty });
        }
      });

      // Loading state
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }

      // Step 1: Add all items to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || data.message || 'Could not add items to cart');
            });
          }
          return res.json();
        })
        .then(function () {
          // Step 2: Fetch fresh section HTML for the cart drawer
          var cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer) {
            // No cart drawer, redirect to cart page
            window.location.href = '/cart';
            return;
          }

          var shopifySection = cartDrawer.closest('.shopify-section');
          var sectionId = shopifySection
            ? shopifySection.id.replace('shopify-section-', '')
            : 'cart-drawer';

          return fetch('/?sections=cart-icon-bubble,' + sectionId)
            .then(function (res) { return res.json(); })
            .then(function (sections) {
              // Step 3: Render fresh cart drawer with all items and open it
              cartDrawer.renderContents({ sections: sections }, true);
            });
        })
        .catch(function (err) {
          console.error('[product-upsells]', err);
          alert(err.message || 'Something went wrong adding items to your cart.');
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
        });
    }, true); // <-- capture phase: fires before theme's bubble-phase handler
  });
})();